import React, { useState, useEffect } from 'react';
import Popper from '@mui/material/Popper';
import { ClickAwayListener } from '@mui/material';

export default function IconWithPopper(props) {
  const { icon, children, logoutStatus } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    if (event?.target?.localName === 'body') {
      return;
    }
    if (anchorEl && anchorEl.contains(event?.target)) {
      return;
    }
    setAnchorEl(anchorEl ? null : event?.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  useEffect(() => {
    setAnchorEl(null);

    if (logoutStatus) handleClick();
  }, [window.location.pathname, logoutStatus]);

  return (
    <>
      <div aria-describedby={id} role="presentation" onClick={handleClick}>
        {icon}
      </div>
      {anchorEl && (
        <ClickAwayListener onClickAway={handleClick}>
          <Popper
            id={id}
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            modifiers={[
              {
                name: 'offset',
                options: {
                  offset: [0, 18]
                }
              }
            ]}
            sx={{ zIndex: 10 }}
          >
            {children}
          </Popper>
        </ClickAwayListener>
      )}
    </>
  );
}
